import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableSortLabel,
  TextField,
  InputAdornment,
  Stack,
  Button,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import DateFormatter from "./DateFormatter";
import ExportToExcelBTN from "./ExportToExcelBTN";

// Helper functions for sorting data
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const EnhancedTable = ({ columns, data }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState(columns[0].id);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filter, setFilter] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filteredData = data.filter((row) =>
    columns.some((column) =>
      row[column.id]?.toString().toLowerCase().includes(filter.toLowerCase())
    )
  );
  const renderCellContent = (column, row) => {
    if (column.idx < 2) {
      return row[column.id];
    } else if (column.idx == 2) {
      return row.LoginTime;
    } else if (column.idx == 3) {
      return row.LogoutTime;
    } else {
      return "NA";
    }
  };

  return (
    <Paper sx={{ width: "100%", mb: 2 }}>
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search..."
          width="200px"
          onChange={handleFilterChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ margin: 1 }}
        />
        <ExportToExcelBTN data={data} />
      </Stack>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  sortDirection={orderBy === column.id ? order : false}
                  sx={{
                    color: "#D10101",
                    textTransform: "uppercase",
                    padding: "10px",
                    fontWeight: 600,
                  }}
                >
                  <TableSortLabel>{column.label}</TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {stableSort(filteredData, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow
                  hover
                  key={index}
                  sx={
                    row.Status === "Late" && {
                      backgroundColor: "#F1948A",
                    }
                  }
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ padding: "10px" }}
                  >
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  {columns.map(
                    (column) => (
                      // column.id === "LoginTime" || column.id === "LogoutTime" ? (
                      //   <TableCell key={column.id} sx={{ padding: "10px" }}>
                      //     <DateFormatter date={row[column.id]} />
                      //   </TableCell>
                      // ) : (
                      <TableCell key={column.id} sx={{ padding: "10px" }}>
                        {renderCellContent(column, row)}
                      </TableCell>
                    )
                    // )
                  )}
                </TableRow>
              ))}
            {filteredData.length === 0 && (
              <TableRow
                style={{ height: 53 * (rowsPerPage - filteredData.length) }}
              >
                <TableCell colSpan={columns.length + 1} align="center">
                  No records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default EnhancedTable;

// import React, { useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Paper,
//   Typography,
// } from "@mui/material";

// const EnhancedTable = ({ data, columns }) => {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   function fn(dateString, val) {
//     const date = new Date(dateString);
//     const dateOptions = {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//       timeZone: "UTC", // Explicitly setting the timezone to UTC
//     };
//     const timeOptions = {
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//       timeZone: "UTC", // Explicitly setting the timezone to UTC
//     };
//     const formattedDate = new Intl.DateTimeFormat("en-US", dateOptions).format(
//       date
//     );
//     const formattedTime = new Intl.DateTimeFormat("en-US", timeOptions).format(
//       date
//     );
//     if (val == 1) {
//       return (
//         <>
//           <p>{formattedTime}</p>
//         </>
//       );
//     } else {
//       return (
//         <>
//           <p>{formattedDate}</p>
//         </>
//       );
//     }
//   }
//   const renderCellContent = (column, row) => {
//     if (column.id < 2) {
//       return row[column.label];
//     } else if (column.id == 2) {
//       return fn(row[column.label], 2);
//     } else if (column.id === 3) {
//       return fn(row[column.label], 1);
//     } else {
//       return row.LogInTime === row.LogoutTime ? "NA" : fn(row[column.label], 1);
//     }
//   };
//   return (
//     <Paper>
//       {data.length === 0 ? (
//         <Typography variant="h6" align="center" style={{ margin: "20px" }}>
//           No data available
//         </Typography>
//       ) : (
//         <>
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   {columns.map((column) => (
//                     <TableCell key={column.id}>{column.label}</TableCell>
//                   ))}
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {data
//                   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                   .map((row, index) => (
//                     <TableRow key={index}>
//                       {columns.map((column) => (
//                         <TableCell key={column.id}>
//                           {renderCellContent(column, row)}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <TablePagination
//             rowsPerPageOptions={[5, 10, 25]}
//             component="div"
//             count={data.length}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//           />
//         </>
//       )}
//     </Paper>
//   );
// };

// export default EnhancedTable;
